import React from "react";
import PropTypes from "prop-types";
import FaqList from "common/components/faqs";
import { v4 } from "uuid";
import classnames from "classnames";

const Faq = ({ questions, title, className, background, twoColumns }) => (
  <div
    key={v4()}
    className={classnames("block block-faqs thick", className, background)}
  >
    <div className="row columns">
      <div className="block-header">
        <h2>{title}</h2>
      </div>
    </div>
    {twoColumns ? (
      <div className="row">
        <div className="columns show-for-small-only small-16">
          <FaqList data={questions} />
        </div>
        <div className="columns hide-for-small-only small-16 medium-8">
          <FaqList data={questions.slice(0, questions.length / 2)} />
        </div>
        <div className="columns hide-for-small-only small-16 medium-8">
          <FaqList data={questions.slice(questions.length / 2)} />
        </div>
      </div>
    ) : (
      <div className="row align-center">
        <div className="small-16 medium-10 columns">
          <FaqList data={questions} />
        </div>
      </div>
    )}
  </div>
);

Faq.propTypes = {
  questions: PropTypes.array,
  title: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.string,
  twoColumns: PropTypes.bool,
};

export default Faq;
